import { Box } from '@mui/material';
import React from 'react';
import { CalendarPartner, Integration } from '../../../types/Integration';
import { UserSettingsCollapseKeys } from '../../../types/User';
import GoogleEventIntegration from './GoogleEventIntegration';
import OutlookEventIntegration from './OutlookEventIntegration';
import AccordionSection from '../../AccordionSection';

type Props = {
  integrations: Integration[];
};

// Mapping of CalendarPartner to corresponding component
const partnerComponentMap = {
  [CalendarPartner.GOOGLE]: GoogleEventIntegration,
  [CalendarPartner.OUTLOOK]: OutlookEventIntegration,
};

export default function IntegrationsSection({ integrations }: Props) {
  return (
    <AccordionSection collapseId={UserSettingsCollapseKeys.EVENT_ITEM_INTEGRATIONS} title="Calendar Integrations">
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        {integrations.map((integration) => {
          const Component = partnerComponentMap[integration.partner];
          if (!Component) return null;

          return <Component key={integration.partner} integration={integration} />;
        })}
      </Box>
    </AccordionSection>
  );
}
